import TrackType from '@jbrowse/core/pluggableElementTypes/TrackType';
import { createBaseTrackModel } from '@jbrowse/core/pluggableElementTypes/models';
import configSchemaF from './configSchema';
export default (function (pm) {
  pm.addTrackType(function () {
    var configSchema = configSchemaF(pm);
    return new TrackType({
      name: 'VariantTrack',
      displayName: 'Variant track',
      configSchema: configSchema,
      stateModel: createBaseTrackModel(pm, 'VariantTrack', configSchema)
    });
  });
});